import * as types from './types'
import Cookies from 'js-cookie'

const state = {
  fetched: true,
  title: null,
  type: null,
  name: null,
  id: Cookies.get('id'),
  logo: null,
  withdraw_min_amount: null,
  ga_id: Cookies.get('ga_id') ? Cookies.get('ga_id') : null,
  favicon_url: null,
}

const mutations = {
  [types.FETCHED]: (state) => {
    state.fetched = false
  },
  [types.SET]: (state, { title, type, name, id, logo, withdraw_min_amount, ga_id, favicon_url }) => {
    Cookies.set('id', id)
    Cookies.set('ga_id', ga_id)
    Object.assign(state, {
      title,
      type,
      name,
      id,
      logo,
      withdraw_min_amount,
      ga_id,
      favicon_url,
    })
  },
}

export default {
  namespace: true,
  state,
  mutations,
}
